const Image = ({ content }) => {
  const image = content.content
  if (!image) {
    return null
  }
  const ImageContent = (content) => {
    if (content.className === "withH1") {
      return (
        <h1>
          <img alt={content.title} src={image.file.url} />
        </h1>
      )
    }

    return <img alt={content.title} src={image.file.url} />
  }

  return <div className={`column column__edge-compute-use-cases ${content.className} `}>{ImageContent(content)}</div>
}

export default Image
